import { render, staticRenderFns } from "./ReviewProblem.vue?vue&type=template&id=784d8a90&scoped=true&lang=pug&"
import script from "./ReviewProblem.vue?vue&type=script&lang=ts&"
export * from "./ReviewProblem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784d8a90",
  null
  
)

export default component.exports